
import Vue from 'vue';
import { ContentModel } from '@descomplica/dex-models';
import Content from './contents/Content.vue';

export default Vue.extend({
  components: {
    Content,
  },
  props: {
    contents: {
      type: Array as Vue.PropType<ContentModel[]>,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
});
